import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const reportPromoApi = createApi({
  reducerPath: 'reportPromoApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['reportPromo'],
  endpoints: () => ({}),
});
